import { useEffect, useRef } from "react";
import mitt, { Emitter } from "../emitter";

function useEmitter<Events extends Record<string | symbol, unknown>>() {
  const emitterRef = useRef<Emitter<Events> | null>(null);

  if (!emitterRef.current) {
    emitterRef.current = mitt<Events>();
  }

  useEffect(() => {
    return () => {
      emitterRef.current = null;
    };
  }, []);

  return emitterRef.current;
}

export { useEmitter };
